// extracted by mini-css-extract-plugin
export default {"root":"VerifyPhonePrompt_root__rYzmD","text":"VerifyPhonePrompt_text__3brw6","button":"VerifyPhonePrompt_button__ai-Hm"};